import styled from 'styled-components'

import { Flex } from 'ui/chandra'

const SelectBoxBase = styled(Flex)`
  align-items: center;
  transition: border 0.25s ease-in-out;
  border: 1px solid
    ${(props) =>
      props.selected ? props.theme.colors.black : props.theme.colors.grey3};
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  position: relative;
  font-weight: ${(props) => (props.selected ? '700' : '500')};
  color: ${(props) =>
    props.selected ? props.theme.colors.black : props.color};
  background-color: ${(props) =>
    props.selected ? props.theme.colors.smoke : props.theme.colors.white};
`

export default SelectBoxBase
